import Cookies from 'universal-cookie';

export enum FeatureFlagsName {
  SMARTER_SEARCH_LAUNCH_CLUSTER = 'SMARTER_SEARCH_LAUNCH_CLUSTER',
  REMOTE_SEARCH_FILTER = 'REMOTE_SEARCH_FILTER',
  REDUCED_DUPLICATED_APPLY = 'REDUCED_DUPLICATED_APPLY',
  BEHAVIOURAL_CUES_FILTERS_ENABLED = 'BEHAVIOURAL_CUES_FILTERS_ENABLED',
}

const cookies = new Cookies();

export const SMARTER_SEARCH_CLUSTERS = [
  'default',
  'ph-launch',
  'end-state-launch',
] as const;

export type SmarterSearchCluster = (typeof SMARTER_SEARCH_CLUSTERS)[number];

// defaults to 'default' cluster if no cookie
export const selectSmarterSearchCluster = (): SmarterSearchCluster =>
  cookies.get(FeatureFlagsName.SMARTER_SEARCH_LAUNCH_CLUSTER) ??
  SMARTER_SEARCH_CLUSTERS[0];

export const isFeatureFlag = (featureToggle: FeatureFlagsName) =>
  Boolean(cookies.get(featureToggle));
